import React from 'react';
import { Card as MuiCard, CardProps as MuiCardProps } from '@material-ui/core';
import styled from 'styled-components';
import { FullHeight, Padded } from '../../types';
import { TypographyProps as BaseTypographyProps, Typography } from '../Typography';

export type CardProps = MuiCardProps & FullHeight;

const Card = styled(({ fullHeight, ...other }: CardProps) => <MuiCard {...other} />)`
    ${({ fullHeight }) => `
        ${fullHeight ? `height: 100%;` : ``} 
    `}
    && {
        border-radius: 10px;
    }
    width: 100%;
`;
export const SquareCard = styled(MuiCard)`
    && {
        border-radius: 10px;
        ${({ theme }) => `
            ${theme.breakpoints.up('md')} {
                border-radius: 0;
            }
        `}
        box-shadow: 0px 10px 24px rgba(0, 0, 0, 0.15);
    }
`;

export const CardContent = styled.div<Padded>`
    ${({ padding, theme }) => `
        ${padding ? `padding: ${theme.spacing(padding)}px;` : ``}
    `}
`;

type TypographyProps = Omit<BaseTypographyProps, 'variant' | 'component' | 'ref'>;

export const CardTitle = styled(
    React.forwardRef<HTMLHeadingElement, Omit<TypographyProps, 'innerRef'>>(
        (props, ref) => <Typography {...props} variant='overline' component='h3' innerRef={ref} />)
)`
    ${({ theme }) => `
        && {
            color: ${theme.palette.text.primary};
        }
    `}
`;

export default Card;
